export default {
    baseStyle: {
        button: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            variant: 'unstyled',
            sx: {
                '&:hover [data-not-hovered="button"]': {
                    display: 'none'
                },

                '&:not(:hover) [data-hovered="button"]': {
                    display: 'none'
                }
            }
        }
    },
    variants: {
        productTile: {
            button: {
                position: 'absolute',
                bottom: 0,
                right: 0,
                width: '45px',
                height: '45px',
                paddingLeft: '5px',
                paddingTop: '5px'
            }
        },
        cart: {
            button: {
                backgroundColor: 'stokkeGray.bright',
                minWidth: '2.5rem',
                width: '2.5rem',
                height: '2.5rem',
                borderRadius: '2rem',
                sx: {
                    // HeartBGWhiteIcon can be styled with the --background-color css variable
                    '--background-color': 'transparent'
                }
            }
        },
        imageGallery: {
            button: {
                position: 'absolute',
                top: {base: 3, lg: 6},
                right: {base: 4, lg: 6},
                margin: '-10.5px',
                h: '45px',
                w: '45px'
            }
        }
    },
    parts: ['button']
}
